// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"434":"a4c8bac9","909":"6425704b"}[chunkId] + ".chunk.js";
};